'use client';

import { logError } from '@util/logError';
import { useEffect } from 'react';

export default function ErrorCatcher() {
  useEffect(() => {
    const onError = (e: ErrorEvent) => {
      if (
        e?.message?.includes('ChunkLoadError') ||
        e?.message?.includes('Loading chunk')
      ) {
        logError(e, 'ChunkLoadError');
      }

      if (
        e?.message
          ?.toLowerCase()
          .includes('recaptcha placeholder must be an element or id')
      ) {
        logError(e, 'RecaptchaError');
      }
    };
    window.addEventListener('error', onError);
    return () => window.removeEventListener('error', onError);
  }, []);

  return <></>;
}
